import React from 'react';
import styled from 'styled-components';
import Box from 'components/Box';
import Text from 'components/Text';
import NumberCustomersCustom from './NumberCustomersCustom';

type Props = {
  value?: number;
  onChange?: (value: number) => void;
  max?: number;
};

const NumberCustomers = ({ value = 1, onChange = () => undefined, max = 10 }: Props) => {
  const items = Array.from({ length: max }, (_, i) => i + 1);
  return (
    <Container>
      <Text variant='H7'> Number customers </Text>
      <Grid>
        {items.map((num) => (
          <ItemButton
            key={num}
            type='button'
            $active={num === value}
            onClick={() => onChange(num)}
          >
            {num}
          </ItemButton>
        ))}
        <NumberCustomersCustom value={value} onChange={onChange} />
      </Grid>
    </Container>
  );
};

export default NumberCustomers;

const Container = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px 16px;
  border-radius: 5px;
  background: #EEF4FF;
  filter: drop-shadow(1px -2px 1px rgba(0, 0, 0, 0.10));
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 10px;
`;

const ItemButton = styled.button<{ $active?: boolean }>`
  height: 46px;
  border-radius: 5px;
  border: none;
  cursor: pointer;
  font-family: Poppins;
  font-size: 16px;
  font-weight: 600;
  color: ${({ $active }) => ($active ? '#fff' : '#1D2129')};
  background: ${({ $active }) => ($active ? '#2D67F2' : '#FFF')};
  box-shadow: 0px 2px 6px rgba(0,0,0,0.08);
`;


